import { PRODUCT_FORM_TYPES } from '../consts';
import { IEntityContent } from './Common';

export interface IProduct {
	id: number;
	name: string;
	slug: string;
	type: string;
	price: number;
	sortNumber: number;
	content: IEntityContent;
	imageUrl: string;
	isPublished: boolean;
	detailsFormId: PRODUCT_FORM_TYPES;
}

export interface IProductDTO {
	name: string;
	type: string;
	content: IEntityContent;
	imageUrl: string;
	isPublished?: boolean;
}

export interface IProductRO {
	id: number;
	slug: string;
	type: string;
	sortNumber: number;
	content: IEntityContent;
	imageUrl: string;
	isPublished: boolean;
}

export enum ProductType {
	SERVICE = '1',
	SUBSCRIPTION_PLAN = '2',
}
